import React, { useEffect } from "react";
import Section2 from "./Section2";
import OurStory from "./OurStory";
import WhySenior from "./WhySenior";
import Hero from "./Hero";
import Footer from "../../components/Footer";
import { toast } from "react-toastify";
import heroPolyLight from "../../assets/waves/heroPolyLight.svg";
import heroPolyDark from "../../assets/waves/heroPolyDark.svg";

const Home = (props) => {
  useEffect(() => {
    if (window.location.pathname === "/loginsucess") {
      toast.success("Login Successful!");
    }
  }, []);

  return (
    <div
      className="w-full min-h-screen bg-no-repeat bg-center bg-cover dark:bg-[#0f172a] transition-colors duration-300"
      style={{
        backgroundImage:
          props.theme === "dark"
            ? `url(${heroPolyDark})`
            : `url(${heroPolyLight})`,
        backgroundAttachment: "fixed"
      }}
    >
      <Hero theme={props.theme} />
      <Section2 theme={props.theme} />
      <OurStory theme={props.theme} />
      <WhySenior theme={props.theme} />
      <Footer theme={props.theme} />
    </div>
  );
};

export default Home;